import React, { createContext, useContext, useState } from "react";

type FriendlyCaptchaStatusContext = {
  setCaptchaSolution: (solution: string) => void;
  captchaSolution: string | undefined;
  isCaptchaSolved: boolean;
};

const FriendlyCaptchaStatusContext = createContext<
  FriendlyCaptchaStatusContext | undefined
>(undefined);

export const FriendlyCaptchaStatusProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [captchaSolution, setCaptchaSolution] = useState<string>();
  const value: FriendlyCaptchaStatusContext = {
    captchaSolution,
    setCaptchaSolution,
    isCaptchaSolved: !!captchaSolution
  };

  return (
    <FriendlyCaptchaStatusContext.Provider value={value}>
      {children}
    </FriendlyCaptchaStatusContext.Provider>
  );
};

export const useFriendlyCaptchaStatus = () => {
  const context = useContext(FriendlyCaptchaStatusContext);
  if (!context) {
    throw new Error(
      "useFriendlyCaptchaStatus must be used within a FriendlyCaptchaStatusProvider"
    );
  }
  return context;
};
export default FriendlyCaptchaStatusProvider;
